// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3hIEj","savePackageButton":"ClientWallet_savePackageButton__1Foe-"};